var provider = {

	color_names: ['ЦіаноБлакитний', 'АлізариновийЧервоний', 'Амарантовий', 
		'АмарантовоРожевий', 'Бурштиновий', 'ЯскравоБурштиновий', 'Аметистовий', 
		'Андроїдний зелений', 'Абрикосовий', 'КолірМорськоїХвилі', 'ЗеленийАрмійський', 
		'Арсеновий', 'Спаржевий', 'АтомнийМандаріновий', 'ЗолотистоКаштановий', 'ЯсноЛазуровий', 
		'НіжноБлакитний', 'Бежевий', 'Бістр', 'Чорний', 'Синій', 'БлакитноЗелений', 
		'БлакитноФіолетовий', 'Дерева', 'ВодаПляжаБонді', 'БлакитнийБрандейса', 
		'Латунний', 'ЯскравоЗелений', 'ЯскравоРожевий', 'ЯскравоБірюзовий', 
		'ЯскравоФіолетовий', 'ДіамантовоРожевий', 'НіжноРожевий', 'Мисливський', 
		'Бронзовий', 'Брунатний', 'ШкіраБуйвола', 'Бургундський', 'ПаленийОранжевий', 
		'ПаленаСіена', 'УмбраПалена', 'Візантійський', 'ТемноЗеленийХакі', 'Кардинал', 
		'Карміновий', 'Морквяний', 'СивавоЗелений', 'ЯсноВишневий', 'Лазуровий', 
		'ЛазуровоСиній', 'Каштановий', 'Шоколадний', 'Цинамоновий', 'Кобальтовий', 
		'Мідний', 'Кораловий', 'Кукурудзяний', 'Блаватний', 'Кремовий', 'Малиновий', 
		'Ціан', 'ТемноБрунатний', 'ТемноЛазурний', 'ТемноКаштановий', 'ТемноКораловий',
		'ТемноЗолотий', 'ТемноЗелений', 'ТемнийІндиго', 'ТемнийХакі', 'ТемноОливковий', 
		'ТемнийПастельноЗелений', 'ТемноПерсиковий', 'ТемноРожевий', 'ТемноЛососевий',
		'ТемноКарміновий', 'ТемноАспіднийCірий', 'ТемнийВесняноЗелений', 'ТемнийЖовтоБрунатний',
		'ТемноМандариновий', 'ТемнийЗеленийЧай', 'ТемноБірюзовий', 'ГлибокийФіолетовий',
		'Джинсовий', 'ЗахиснийСиній', 'Смарагдовий', 'Баклажановий', 'ЗеленийПапороть', 
		'Лляний', 'Фуксія', 'Гумігут', 'Золотий', 'ЗолотавоБерезовий', 'Сірий', 
		'СіраСпаржа', 'Зелений', 'ЖовтоЗелений', 'СвітлоСиній', 'Геліотроп', 
		'ГарячоРожевий', 'Індиго', 'МіжнароднийПомаранчевий', 'Нефритовий', 'Хакі', 
		'СинійКлейна', 'Лавандний', 'РожевоЛавандний', 'Лимонний', 'ЛимонноКремовий', 
		'ЯсноБрунатний', 'Бузковий', 'Лайм', 'Пурпурний', 'Малахітовий', 
		'БрунатоМалиновий', 'РожевоЛіловий', 'ОпівнічноСиній', 'Зелена м\'ята', 
		'ЗеленийМох', 'РожевийМаунтбеттена', 'Гірчичний', 'БілийНавахо', 
		'ТемноСиній', 'Вохра', 'СтареЗолото', 'Оливковий', 'НіжноОливковий', 
		'Помаранчевий', 'Орхідея'
	]
	
};

module.exports = provider;
